export default __webpack_public_path__ + "static/media/smsicon.db56ed40.svg";